import { Tabs, Card, Typography, Row, Col, Image, Space, Tag, Avatar } from 'antd';
import React from 'react';
import InfoRow from '../../InfoRow/InfoRow';
import PlanDetails from '../PlanDetails/PlanDetails';

const { Title } = Typography;
const { TabPane } = Tabs;



const FranchiseDetails = ({ data }) => {
  
  return (
    <Card>
      <Tabs defaultActiveKey="1" centered>
        {/* data Details */}
        <TabPane tab="data Details" key="1">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}   ><InfoRow
            label="Business Name" value={data?.businessName} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="GST Number" value={data?.gstNumber} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Entity Type" value={data?.entityType} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Category" value={data?.businessCategory} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Address" value={`${data?.businessAddress?.address} ${data?.businessAddress?.street} ${data?.businessAddress?.city} ${data?.businessAddress?.state}   ${data?.businessAddress?.country}  ` } /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Overview" value={data?.businessOverview} /></Col>
            <Col xs={24} sm={12} >
              <InfoRow label="Business Photo Url" />
              <Image
                src={data?.businessPhotoUrl}
              />
            </Col>
            <Col xs={24} sm={12} >
              <InfoRow label="Logo Photo Url" />
              <Image
                src={data?.logoPhotoUrl}
              />
            </Col>
            <Col xs={24} sm={12} >
              <InfoRow label="data  Fee" value={data?.franchiseFee} />
            </Col>
            <Col xs={24} sm={12} >
              <InfoRow label="Royality Percentage" value={data?.royaltyPercentage} />
            </Col>
            <Col xs={24} sm={12} >
              <InfoRow label="Required Area(sq ft)" value={data?.requiredAreaSqFt} />
            </Col>
          
            <Col xs={24} sm={12} ><InfoRow label="ROI" value={data?.expectedROI} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Loan Assistance Options" value={data?.loanAssistanceOptions} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Support Provided" value={data?.supportProvided} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Territory Availability" value={data?.territoryAvailability} /></Col>
            <Col xs={24} sm={12} ><InfoRow label="Investment" value={`${data?.minimumInvestmentRequired} - ${data?.maximumInvestmentRequired}`} /></Col>



            {data?.status ===
              'accepted' ? <div>
                <div>
                  <Tag>
                    <span style={{ color: 'green' }}>Accepted</span>
                  </Tag>
                </div>

                <Col xs={24} sm={12} ><InfoRow label="Start Date" value={data?.start_date} /></Col>
                <Col xs={24} sm={12} ><InfoRow label="End Date" value={data?.end_date} /></Col>
                

            </div>
              : <div>
                
                <title>Status</title>
                <Tag color={'red'}>
                  {data?.status === 'pending' ? 'Pending' : 'Rejected'}
                </Tag>
              </div>             
}
          </Row>
         
          <Space>
            <Title level={5}>Payment Status:</Title>
            <Tag color={data?.payment_status === 'paid' ? 'green' : 'red'}>
              {data?.payment_status === 'paid' ? 'Paid' : 'Not Paid'}
            </Tag>
          </Space>
        </TabPane>

        {/* User Details */}
        <TabPane tab="User Details" key="2">
          <Row gutter={[16, 16]}>
            <Col
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: "center",
                alignItems :"center"
              }}
              
              xs={24}>
              <Avatar
                
                size={123}
                src={data?.user?.profilePic}
              />
            </Col>
            <Col xs={24} sm={12}><InfoRow label="Name" value={data?.user?.name} /></Col>
            <Col xs={24} sm={12}><InfoRow label="Email" value={data?.user?.email} /></Col>
            <Col xs={24} sm={12}><InfoRow label="Phone" value={data?.user?.phoneNumber} /></Col>
          </Row>
        </TabPane>

        {/* Plan Details */}
        <TabPane tab="Plan Details" key="3">
          <PlanDetails
          plan={data?.plan}
          />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default FranchiseDetails;